// // import React, { useState, useEffect } from 'react';
// // import {
// //   Box,
// //   Button,
// //   Card,
// //   CardContent,
// //   Typography,
// //   TextField,
// //   InputAdornment,
// //   Chip,
// //   IconButton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Alert,
// //   Grid,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// // } from '@mui/material';
// // import { DataGrid } from '@mui/x-data-grid';
// // import {
// //   Search,
// //   Add,
// //   Visibility,
// //   Edit,
// //   Delete,
// //   Phone,
// //   People,
// //   CheckCircle,
// //   Block,
// //   PersonOff,
// // } from '@mui/icons-material';
// // import { Formik, Form } from 'formik';
// // import * as Yup from 'yup';
// // import apiService from '../services/apiService';

// // const PassengersPage = () => {
// //   const [passengers, setPassengers] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState('');
// //   const [searchQuery, setSearchQuery] = useState('');
// //   const [openViewDialog, setOpenViewDialog] = useState(false);
// //   const [openAddDialog, setOpenAddDialog] = useState(false);
// //   const [editMode, setEditMode] = useState(false);
// //   const [selectedPassenger, setSelectedPassenger] = useState(null);

// //   useEffect(() => {
// //     fetchPassengers();
// //   }, []);

// //   const fetchPassengers = async () => {
// //     try {
// //       setLoading(true);
// //       const response = await apiService.getPassengers();

// //       if (response.success) {
// //         setPassengers(response.data);
// //         setError('');
// //       } else {
// //         setError(response.message || 'Failed to load passengers');
// //         setPassengers([]);
// //       }
// //     } catch (err) {
// //       console.error('Passengers error:', err);
// //       setError('Failed to load passengers. Please check your connection and try again.');
// //       setPassengers([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleAddPassenger = () => {
// //     setEditMode(false);
// //     setSelectedPassenger(null);
// //     setOpenAddDialog(true);
// //   };

// //   const handleEditPassenger = (passenger) => {
// //     setEditMode(true);
// //     setSelectedPassenger(passenger);
// //     setOpenAddDialog(true);
// //   };

// //   const handleSubmitPassenger = async (values, { setSubmitting }) => {
// //     try {
// //       console.log('Submitting passenger data:', { name: values.name, gender: values.gender, phone: values.phone, status: values.status });

// //       let response;
// //       if (editMode) {
// //         response = await apiService.updatePassenger(selectedPassenger.id, {
// //           name: values.name,
// //           gender: values.gender,
// //           phone: values.phone,
// //           status: values.status,
// //         });
// //       } else {
// //         response = await apiService.addPassenger({
// //           name: values.name,
// //           gender: values.gender,
// //           phone: values.phone,
// //           status: values.status,
// //         });
// //       }

// //       console.log('API Response:', response);

// //       if (response.success) {
// //         alert(`Passenger ${editMode ? 'updated' : 'added'} successfully`);
// //         setOpenAddDialog(false);
// //         setSelectedPassenger(null);
// //         setEditMode(false);
// //         fetchPassengers();
// //       } else {
// //         console.error('API returned error:', response);
// //         alert(response.message || `Failed to ${editMode ? 'update' : 'add'} passenger`);
// //       }
// //     } catch (err) {
// //       console.error(`${editMode ? 'Update' : 'Add'} passenger error:`, err);
// //       console.error('Error details:', err.response?.data || err.message);
// //       alert(`Failed to ${editMode ? 'update' : 'add'} passenger: ${err.response?.data?.message || err.message || 'Unknown error'}`);
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   const handleViewPassenger = async (passenger) => {
// //     setSelectedPassenger(passenger);
// //     setOpenViewDialog(true);
// //   };

// //   const validationSchema = Yup.object({
// //     name: Yup.string().required('Name is required').min(2, 'Name must be at least 2 characters'),
// //     gender: Yup.string().required('Gender is required'),
// //     phone: Yup.string()
// //       .required('Phone number is required')
// //       .matches(/^\+?[1-9]\d{1,14}$/, 'Please enter a valid phone number'),
// //     status: Yup.string().required('Status is required'),
// //   });

// //   const handleDeletePassenger = async (passengerId) => {
// //     if (!window.confirm('Are you sure you want to delete this passenger? This action cannot be undone.')) {
// //       return;
// //     }

// //     try {
// //       const response = await apiService.deletePassenger(passengerId);

// //       if (response.success) {
// //         alert('Passenger deleted successfully');
// //         fetchPassengers();
// //       } else {
// //         alert(response.message || 'Failed to delete passenger');
// //       }
// //     } catch (err) {
// //       alert('Failed to delete passenger');
// //     }
// //   };

// //   const getStatusChip = (status) => {
// //     const statusConfig = {
// //       active: { label: 'Active', color: 'success' },
// //       blocked: { label: 'Blocked', color: 'error' },
// //       inactive: { label: 'Inactive', color: 'default' },
// //     };

// //     const config = statusConfig[status] || statusConfig.inactive;
// //     return <Chip label={config.label} color={config.color} size="small" />;
// //   };

// //   const columns = [
// //     {
// //       field: 'name',
// //       headerName: 'Passenger Name',
// //       width: 200,
// //       renderCell: (params) => (
// //         <Box>
// //           <Typography variant="body2" fontWeight={600}>
// //             {params.row.name}
// //           </Typography>
// //           <Typography variant="caption" color="text.secondary">
// //             {params.row.phone}
// //           </Typography>
// //         </Box>
// //       ),
// //     },
// //     {
// //       field: 'phone',
// //       headerName: 'Phone Number',
// //       width: 150,
// //     },
// //     {
// //       field: 'status',
// //       headerName: 'Status',
// //       width: 120,
// //       renderCell: (params) => getStatusChip(params.row.status),
// //     },
// //     {
// //       field: 'totalRides',
// //       headerName: 'Total Rides',
// //       width: 120,
// //       valueGetter: (params) => params.row.totalRides || 0,
// //     },
// //     {
// //       field: 'totalSpent',
// //       headerName: 'Total Spent',
// //       width: 130,
// //       renderCell: (params) => `₹${Number(params.row.totalSpent || 0).toLocaleString()}`,
// //     },
// //     {
// //       field: 'rating',
// //       headerName: 'Rating',
// //       width: 100,
// //       renderCell: (params) => (
// //         <Typography variant="body2">
// //           ⭐ {Number(params.row.rating || 5.0).toFixed(2)}
// //         </Typography>
// //       ),
// //     },
// //     {
// //       field: 'created_at',
// //       headerName: 'Joined',
// //       width: 150,
// //       valueGetter: (params) => params.row.created_at ? new Date(params.row.created_at).toLocaleDateString() : '-',
// //     },    
// //     {
// //       field: 'actions',
// //       headerName: 'Actions',
// //       width: 150,
// //       sortable: false,
// //       renderCell: (params) => (
// //         <Box>
// //           <IconButton size="small" onClick={() => handleViewPassenger(params.row)}>
// //             <Visibility fontSize="small" />
// //           </IconButton>
// //           <IconButton size="small" color="primary" onClick={() => handleEditPassenger(params.row)}>
// //             <Edit fontSize="small" />
// //           </IconButton>
// //           <IconButton
// //             size="small"
// //             color="error"
// //             onClick={() => handleDeletePassenger(params.row.id)}
// //           >
// //             <Delete fontSize="small" />
// //           </IconButton>
// //         </Box>
// //       ),
// //     },
// //   ];

// //   const filteredPassengers = passengers.filter((passenger) =>
// //     passenger.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
// //     passenger.phone.includes(searchQuery)
// //   );

// //   return (
// //     <Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
// //         <Box>
// //           <Typography variant="h4" fontWeight="bold" gutterBottom>
// //             Passengers
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary">
// //             Manage all passenger accounts
// //           </Typography>
// //         </Box>
// //         <Button variant="contained" startIcon={<Add />} onClick={handleAddPassenger}>
// //           Add Passenger
// //         </Button>
// //       </Box>

// //       {error && (
// //         <Alert severity="error" sx={{ mb: 3 }}>
// //           {error}
// //         </Alert>
// //       )}

// //       <Card>
// //         <CardContent>
// //           <TextField
// //             fullWidth
// //             placeholder="Search by name or phone..."
// //             value={searchQuery}
// //             onChange={(e) => setSearchQuery(e.target.value)}
// //             InputProps={{
// //               startAdornment: (
// //                 <InputAdornment position="start">
// //                   <Search />
// //                 </InputAdornment>
// //               ),
// //             }}
// //             sx={{ mb: 3 }}
// //           />

// //           <DataGrid
// //             rows={filteredPassengers}
// //             columns={columns}
// //             pageSize={10}
// //             rowsPerPageOptions={[10, 25, 50]}
// //             disableSelectionOnClick
// //             autoHeight
// //             loading={loading}
// //             sx={{
// //               '& .MuiDataGrid-cell:focus': {
// //                 outline: 'none',
// //               },
// //             }}
// //           />
// //         </CardContent>
// //       </Card>

// //       {/* View Passenger Dialog */}
// //       <Dialog open={openViewDialog} onClose={() => setOpenViewDialog(false)} maxWidth="md" fullWidth>
// //         <DialogTitle>Passenger Details</DialogTitle>
// //         <DialogContent>
// //           {selectedPassenger && (
// //             <Box sx={{ pt: 2 }}>
// //               <Grid container spacing={3}>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Name</Typography>
// //                   <Typography variant="body1" fontWeight={600}>{selectedPassenger.name}</Typography>
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Phone</Typography>
// //                   <Typography variant="body1">{selectedPassenger.phone}</Typography>
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Gender</Typography>
// //                   <Typography variant="body1">{selectedPassenger.gender || 'Not specified'}</Typography>
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Status</Typography>
// //                   <Box sx={{ mt: 0.5 }}>{getStatusChip(selectedPassenger.status)}</Box>
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Total Rides</Typography>
// //                   <Typography variant="body1">{selectedPassenger.totalRides || 0}</Typography>
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Total Spent</Typography>
// //                   <Typography variant="body1">₹{Number(selectedPassenger.totalSpent || 0).toLocaleString()}</Typography>
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Rating</Typography>
// //                   <Typography variant="body1">⭐ {Number(selectedPassenger.rating || 0.0).toFixed(2)}</Typography>
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography variant="body2" color="text.secondary">Joined Date</Typography>
// //                   <Typography variant="body1">
// //                     {selectedPassenger.created_at ? new Date(selectedPassenger.created_at).toLocaleDateString() : '-'}
// //                   </Typography>
// //                 </Grid>                
// //               </Grid>
// //             </Box>
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* Add/Edit Passenger Dialog */}
// //       <Dialog
// //         open={openAddDialog}
// //         onClose={() => {
// //           setOpenAddDialog(false);
// //           setSelectedPassenger(null);
// //           setEditMode(false);
// //         }}
// //         maxWidth="sm"
// //         fullWidth
// //       >
// //         <DialogTitle>{editMode ? 'Edit' : 'Add'} Passenger</DialogTitle>
// //         <Formik
// //           initialValues={{
// //             name: selectedPassenger?.name || '',
// //             gender: selectedPassenger?.gender || 'Male',
// //             phone: selectedPassenger?.phone || '',
// //             status: selectedPassenger?.status || 'active',
// //           }}
// //           validationSchema={validationSchema}
// //           onSubmit={handleSubmitPassenger}
// //           enableReinitialize
// //         >
// //           {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
// //             <Form>
// //               <DialogContent>
// //                 <Grid container spacing={2}>
// //                   <Grid item xs={12}>
// //                     <TextField
// //                       fullWidth
// //                       name="name"
// //                       label="Name"
// //                       value={values.name}
// //                       onChange={handleChange}
// //                       onBlur={handleBlur}
// //                       error={touched.name && Boolean(errors.name)}
// //                       helperText={touched.name && errors.name}
// //                       placeholder="Enter Full name"
// //                       required
// //                     />
// //                   </Grid>
// //                   <Grid item xs={12}>
// //                     <FormControl fullWidth required>
// //                       <InputLabel>Gender</InputLabel>
// //                       <Select
// //                         name="gender"
// //                         value={values.gender}
// //                         onChange={handleChange}
// //                         onBlur={handleBlur}
// //                         label="Gender"
// //                         error={touched.gender && Boolean(errors.gender)}
// //                       >
// //                         <MenuItem value="Male">Male</MenuItem>
// //                         <MenuItem value="Female">Female</MenuItem>
// //                         <MenuItem value="Transgender">Transgender</MenuItem>
// //                       </Select>
// //                     </FormControl>
// //                   </Grid>
// //                   <Grid item xs={12}>
// //                     <TextField
// //                       fullWidth
// //                       name="phone"
// //                       label="Phone Number"
// //                       value={values.phone}
// //                       onChange={handleChange}
// //                       onBlur={handleBlur}
// //                       error={touched.phone && Boolean(errors.phone)}
// //                       helperText={touched.phone && errors.phone}
// //                       placeholder="+919876543210"
// //                       required
// //                       InputProps={{
// //                         startAdornment: (
// //                           <InputAdornment position="start">
// //                             <Phone />
// //                           </InputAdornment>
// //                         ),
// //                       }}
// //                     />
// //                   </Grid>
// //                   <Grid item xs={12}>
// //                     <FormControl fullWidth required>
// //                       <InputLabel>Status</InputLabel>
// //                       <Select
// //                         name="status"
// //                         value={values.status}
// //                         onChange={handleChange}
// //                         onBlur={handleBlur}
// //                         label="Status"
// //                         error={touched.status && Boolean(errors.status)}
// //                       >
// //                         <MenuItem value="active">Active</MenuItem>
// //                         <MenuItem value="inactive">Inactive</MenuItem>
// //                         <MenuItem value="blocked">Blocked</MenuItem>
// //                       </Select>
// //                     </FormControl>
// //                   </Grid>
// //                 </Grid>
// //               </DialogContent>
// //               <DialogActions>
// //                 <Button onClick={() => {
// //                   setOpenAddDialog(false);
// //                   setSelectedPassenger(null);
// //                   setEditMode(false);
// //                 }}>Cancel</Button>
// //                 <Button type="submit" variant="contained" disabled={isSubmitting}>
// //                   {editMode ? 'Update' : 'Add'} Passenger
// //                 </Button>
// //               </DialogActions>
// //             </Form>
// //           )}
// //         </Formik>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default PassengersPage;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   InputAdornment,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Alert,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Paper,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import {
//   Search,
//   Add,
//   Visibility,
//   Edit,
//   Delete,
//   Phone,
//   People,
//   CheckCircle,
//   Block,
//   PersonOff,
// } from '@mui/icons-material';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import apiService from '../services/apiService';
// import config from '../config/config';

// const PassengersPage = () => {
//   const [passengers, setPassengers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [openAddDialog, setOpenAddDialog] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [selectedPassenger, setSelectedPassenger] = useState(null);
  
//   // Pagination state
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 10,
//   });
  
//   // Add total count state
//   const [totalPassengersCount, setTotalPassengersCount] = useState(0);

//   useEffect(() => {
//     fetchPassengers(paginationModel.page + 1, paginationModel.pageSize);
//   }, [paginationModel.page, paginationModel.pageSize]);

//   const fetchPassengers = async (page = 1, limit = 10) => {
//     try {
//       setLoading(true);
//       const response = await apiService.getPassengers(page, limit);

//       if (response.success) {
//         setPassengers(response.data);
//         setTotalPassengersCount(response.pagination?.total || 0);
//         setError('');
//       } else {
//         setError(response.message || 'Failed to load passengers');
//         setPassengers([]);
//         setTotalPassengersCount(0);
//       }
//     } catch (err) {
//       console.error('Passengers error:', err);
//       setError('Failed to load passengers. Please check your connection and try again.');
//       setPassengers([]);
//       setTotalPassengersCount(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddPassenger = () => {
//     setEditMode(false);
//     setSelectedPassenger(null);
//     setOpenAddDialog(true);
//   };

//   const handleEditPassenger = (passenger) => {
//     setEditMode(true);
//     setSelectedPassenger(passenger);
//     setOpenAddDialog(true);
//   };

//   const handleSubmitPassenger = async (values, { setSubmitting }) => {
//     try {
//       console.log('Submitting passenger data:', { name: values.name, gender: values.gender, phone: values.phone, status: values.status });

//       let response;
//       if (editMode) {
//         response = await apiService.updatePassenger(selectedPassenger.id, {
//           name: values.name,
//           gender: values.gender,
//           phone: values.phone,
//           status: values.status,
//         });
//       } else {
//         response = await apiService.addPassenger({
//           name: values.name,
//           gender: values.gender,
//           phone: values.phone,
//           status: values.status,
//         });
//       }

//       console.log('API Response:', response);

//       if (response.success) {
//         alert(`Passenger ${editMode ? 'updated' : 'added'} successfully`);
//         setOpenAddDialog(false);
//         setSelectedPassenger(null);
//         setEditMode(false);
//         // Refresh current page
//         fetchPassengers(paginationModel.page + 1, paginationModel.pageSize);
//       } else {
//         console.error('API returned error:', response);
//         alert(response.message || `Failed to ${editMode ? 'update' : 'add'} passenger`);
//       }
//     } catch (err) {
//       console.error(`${editMode ? 'Update' : 'Add'} passenger error:`, err);
//       console.error('Error details:', err.response?.data || err.message);
//       alert(`Failed to ${editMode ? 'update' : 'add'} passenger: ${err.response?.data?.message || err.message || 'Unknown error'}`);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleViewPassenger = async (passenger) => {
//     setSelectedPassenger(passenger);
//     setOpenViewDialog(true);
//   };

//   const validationSchema = Yup.object({
//     name: Yup.string().required('Name is required').min(2, 'Name must be at least 2 characters'),
//     gender: Yup.string().required('Gender is required'),
//     phone: Yup.string()
//       .required('Phone number is required')
//       .matches(/^\+?[1-9]\d{1,14}$/, 'Please enter a valid phone number'),
//     status: Yup.string().required('Status is required'),
//   });

//   const handleDeletePassenger = async (passengerId) => {
//     if (!window.confirm('Are you sure you want to delete this passenger? This action cannot be undone.')) {
//       return;
//     }

//     try {
//       const response = await apiService.deletePassenger(passengerId);

//       if (response.success) {
//         alert('Passenger deleted successfully');
//         fetchPassengers(paginationModel.page + 1, paginationModel.pageSize);
//       } else {
//         alert(response.message || 'Failed to delete passenger');
//       }
//     } catch (err) {
//       alert('Failed to delete passenger');
//     }
//   };

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       active: { label: 'Active', color: 'success' },
//       blocked: { label: 'Blocked', color: 'error' },
//       inactive: { label: 'Inactive', color: 'default' },
//     };

//     const config = statusConfig[status] || statusConfig.inactive;
//     return <Chip label={config.label} color={config.color} size="small" />;
//   };

//   // Calculate statistics from current page data
//   const currentPagePassengers = passengers;
//   const activePassengers = currentPagePassengers.filter(p => p.status === 'active').length;
//   const inactivePassengers = currentPagePassengers.filter(p => p.status === 'inactive').length;
//   const blockedPassengers = currentPagePassengers.filter(p => p.status === 'blocked').length;

//   const columns = [
//     {
//       field: 'profile_photo',
//       headerName: 'Driver Photo',
//       width: 100,
//       renderCell: (params) => {
//         const photoUrl = params.row.profile_photo || params.row.photo;
//         if (!photoUrl) {
//           return (
//             <div style={{
//               width: 50,
//               height: 50,
//               borderRadius: '50%',
//               background: '#FFC107',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: 20,
//               color: '#000',
//             }}>
//               {(params.row.name || 'D').charAt(0).toUpperCase()}
//             </div>
//           );
//         }
        
//         const cleanPath = String(photoUrl).trim().replace(/^\/+/, '');
//         const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
//         const fullUrl = `${baseUrl}/${cleanPath}`;
        
//         return (
//           <img 
//             src={fullUrl} 
//             alt={params.row.name || 'Driver'}
//             style={{
//               width: 50,
//               height: 50,
//               borderRadius: '50%',
//               objectFit: 'cover',
//               border: '2px solid #FFC107',
//             }}
//             onError={(e) => {
//               e.target.style.display = 'none';
//             }}
//           />
//         );
//       },
//     },
//     {
//       field: 'name',
//       headerName: 'Passenger Name',
//       width: 200,
//       renderCell: (params) => (
//         <Box>
//           <Typography variant="body2" fontWeight={600}>
//             {params.row.name || 'N/A'}
//           </Typography>
//           <Typography variant="caption" color="text.secondary">
//             {params.row.phone}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'phone',
//       headerName: 'Phone Number',
//       width: 150,
//     },
//     {
//       field: 'status',
//       headerName: 'Status',
//       width: 120,
//       renderCell: (params) => getStatusChip(params.row.status),
//     },
//     {
//       field: 'totalRides',
//       headerName: 'Total Rides',
//       width: 120,
//       valueGetter: (params) => params.row.totalRides || 0,
//     },
//     {
//       field: 'totalSpent',
//       headerName: 'Total Spent',
//       width: 130,
//       renderCell: (params) => `₹${Number(params.row.totalSpent || 0).toLocaleString()}`,
//     },
//     {
//       field: 'rating',
//       headerName: 'Rating',
//       width: 100,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           ⭐ {Number(params.row.rating || 5.0).toFixed(2)}
//         </Typography>
//       ),
//     },
//     {
//       field: 'created_at',
//       headerName: 'Joined',
//       width: 150,
//       valueGetter: (params) => params.row.created_at ? new Date(params.row.created_at).toLocaleDateString() : '-',
//     },    
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <IconButton size="small" onClick={() => handleViewPassenger(params.row)}>
//             <Visibility fontSize="small" />
//           </IconButton>
//           <IconButton size="small" color="primary" onClick={() => handleEditPassenger(params.row)}>
//             <Edit fontSize="small" />
//           </IconButton>
//           <IconButton
//             size="small"
//             color="error"
//             onClick={() => handleDeletePassenger(params.row.id)}
//           >
//             <Delete fontSize="small" />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   // Filter passengers by search query (client-side filtering)
//   const filteredPassengers = passengers.filter((passenger) =>
//     passenger.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     passenger.phone?.includes(searchQuery)
//   );

//   // Summary card component
//   const SummaryCard = ({ title, value, icon, color, bgColor }) => (
//     <Card sx={{ height: '100%', bgcolor: bgColor }}>
//       <CardContent>
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <Box>
//             <Typography variant="body2" color="text.secondary" gutterBottom>
//               {title}
//             </Typography>
//             <Typography variant="h4" fontWeight="bold">
//               {value}
//             </Typography>
//           </Box>
//           <Box
//             sx={{
//               bgcolor: color,
//               borderRadius: '50%',
//               p: 1,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//           >
//             {icon}
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h4" fontWeight="bold" gutterBottom>
//             Passengers
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Manage all passenger accounts
//           </Typography>
//         </Box>
//         <Button variant="contained" startIcon={<Add />} onClick={handleAddPassenger}>
//           Add Passenger
//         </Button>
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       {/* Summary Cards - Using total from pagination */}
//       <Grid container spacing={3} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Total Passengers"
//             value={totalPassengersCount}
//             icon={<People sx={{ color: 'white' }} />}
//             color="#1976d2"
//             bgColor="#e3f2fd"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Active Passengers"
//             value={activePassengers}
//             icon={<CheckCircle sx={{ color: 'white' }} />}
//             color="#2e7d32"
//             bgColor="#e8f5e9"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Inactive Passengers"
//             value={inactivePassengers}
//             icon={<PersonOff sx={{ color: 'white' }} />}
//             color="#ed6c02"
//             bgColor="#fff3e0"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Blocked Passengers"
//             value={blockedPassengers}
//             icon={<Block sx={{ color: 'white' }} />}
//             color="#d32f2f"
//             bgColor="#fde8e8"
//           />
//         </Grid>
//       </Grid>

//       <Card>
//         <CardContent>
//           <TextField
//             fullWidth
//             placeholder="Search by name or phone..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Search />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ mb: 3 }}
//           />

//           <DataGrid
//             rows={filteredPassengers}
//             columns={columns}
//             rowCount={totalPassengersCount}
//             paginationModel={paginationModel}
//             onPaginationModelChange={setPaginationModel}
//             pageSizeOptions={[10, 25, 50]}
//             paginationMode="server"
//             disableRowSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//           />
//         </CardContent>
//       </Card>

//       {/* View Passenger Dialog */}
//       <Dialog open={openViewDialog} onClose={() => setOpenViewDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>Passenger Details</DialogTitle>
//         <DialogContent>
//           {selectedPassenger && (
//             <Box sx={{ pt: 2 }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Name</Typography>
//                   <Typography variant="body1" fontWeight={600}>{selectedPassenger.name || 'N/A'}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Phone</Typography>
//                   <Typography variant="body1">{selectedPassenger.phone}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Gender</Typography>
//                   <Typography variant="body1">{selectedPassenger.gender || 'Not specified'}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Status</Typography>
//                   <Box sx={{ mt: 0.5 }}>{getStatusChip(selectedPassenger.status)}</Box>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Total Rides</Typography>
//                   <Typography variant="body1">{selectedPassenger.totalRides || 0}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Total Spent</Typography>
//                   <Typography variant="body1">₹{Number(selectedPassenger.totalSpent || 0).toLocaleString()}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Rating</Typography>
//                   <Typography variant="body1">⭐ {Number(selectedPassenger.rating || 0.0).toFixed(2)}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Joined Date</Typography>
//                   <Typography variant="body1">
//                     {selectedPassenger.created_at ? new Date(selectedPassenger.created_at).toLocaleDateString() : '-'}
//                   </Typography>
//                 </Grid>                
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add/Edit Passenger Dialog */}
//       <Dialog
//         open={openAddDialog}
//         onClose={() => {
//           setOpenAddDialog(false);
//           setSelectedPassenger(null);
//           setEditMode(false);
//         }}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>{editMode ? 'Edit' : 'Add'} Passenger</DialogTitle>
//         <Formik
//           initialValues={{
//             name: selectedPassenger?.name || '',
//             gender: selectedPassenger?.gender || 'Male',
//             phone: selectedPassenger?.phone || '',
//             status: selectedPassenger?.status || 'active',
//           }}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmitPassenger}
//           enableReinitialize
//         >
//           {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
//             <Form>
//               <DialogContent>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       name="name"
//                       label="Name"
//                       value={values.name}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.name && Boolean(errors.name)}
//                       helperText={touched.name && errors.name}
//                       placeholder="Enter Full name"
//                       required
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <FormControl fullWidth required>
//                       <InputLabel>Gender</InputLabel>
//                       <Select
//                         name="gender"
//                         value={values.gender}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         label="Gender"
//                         error={touched.gender && Boolean(errors.gender)}
//                       >
//                         <MenuItem value="Male">Male</MenuItem>
//                         <MenuItem value="Female">Female</MenuItem>
//                         <MenuItem value="Transgender">Transgender</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       name="phone"
//                       label="Phone Number"
//                       value={values.phone}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.phone && Boolean(errors.phone)}
//                       helperText={touched.phone && errors.phone}
//                       placeholder="+919876543210"
//                       required
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <Phone />
//                           </InputAdornment>
//                         ),
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <FormControl fullWidth required>
//                       <InputLabel>Status</InputLabel>
//                       <Select
//                         name="status"
//                         value={values.status}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         label="Status"
//                         error={touched.status && Boolean(errors.status)}
//                       >
//                         <MenuItem value="active">Active</MenuItem>
//                         <MenuItem value="inactive">Inactive</MenuItem>
//                         <MenuItem value="blocked">Blocked</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => {
//                   setOpenAddDialog(false);
//                   setSelectedPassenger(null);
//                   setEditMode(false);
//                 }}>Cancel</Button>
//                 <Button type="submit" variant="contained" disabled={isSubmitting}>
//                   {editMode ? 'Update' : 'Add'} Passenger
//                 </Button>
//               </DialogActions>
//             </Form>
//           )}
//         </Formik>
//       </Dialog>
//     </Box>
//   );
// };

// export default PassengersPage;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  Search,
  Add,
  Visibility,
  Edit,
  Delete,
  Phone,
  People,
  CheckCircle,
  Block,
  PersonOff,
} from '@mui/icons-material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import apiService from '../services/apiService';
import config from '../config/config';

const PassengersPage = () => {
  const [passengers, setPassengers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedPassenger, setSelectedPassenger] = useState(null);
  
  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  
  // Add total count state
  const [totalPassengersCount, setTotalPassengersCount] = useState(0);
  const [pageInfo, setPageInfo] = useState({ page: 1, totalPages: 1 });

  // Fetch passengers when pagination changes
  useEffect(() => {
    fetchPassengers(paginationModel.page + 1, paginationModel.pageSize);
  }, [paginationModel.page, paginationModel.pageSize]);

  const fetchPassengers = async (page = 1, limit = 10) => {
    try {
      setLoading(true);
      setError('');
      
      const response = await apiService.getPassengers({ page, limit });
      
      // Check if response has the expected structure
      if (response && response.success) {
        setPassengers(response.data || []);
        setTotalPassengersCount(response.pagination?.total || 0);
        setPageInfo({
          page: response.pagination?.page || page,
          totalPages: response.pagination?.totalPages || 1
        });
      } else {
        // If response is an array directly (fallback)
        if (Array.isArray(response)) {
          setPassengers(response);
          setTotalPassengersCount(response.length);
        } else {
          setError(response?.message || 'Failed to load passengers');
          setPassengers([]);
          setTotalPassengersCount(0);
        }
      }
    } catch (err) {
      console.error('Passengers error:', err);
      // More detailed error logging
      if (err.response) {
        console.error('Error response:', err.response);
        setError(`Server error: ${err.response.status} - ${err.response.statusText}`);
      } else if (err.request) {
        console.error('No response received:', err.request);
        setError('No response from server. Please check your connection.');
      } else {
        console.error('Error message:', err.message);
        setError(`Error: ${err.message}`);
      }
      setPassengers([]);
      setTotalPassengersCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleAddPassenger = () => {
    setEditMode(false);
    setSelectedPassenger(null);
    setOpenAddDialog(true);
  };

  const handleEditPassenger = (passenger) => {
    setEditMode(true);
    setSelectedPassenger(passenger);
    setOpenAddDialog(true);
  };

  const handleSubmitPassenger = async (values, { setSubmitting }) => {
    try {
      const payload = {
        name: values.name,
        gender: values.gender.toLowerCase(),
        phone: values.phone,
        status: values.status,
      };

      let response;
      if (editMode) {
        response = await apiService.updatePassenger(selectedPassenger.id, payload);
      } else {
        response = await apiService.addPassenger(payload);
      }

      if (response && response.success) {
        alert(`Passenger ${editMode ? 'updated' : 'added'} successfully`);
        setOpenAddDialog(false);
        setSelectedPassenger(null);
        setEditMode(false);
        // Refresh current page
        fetchPassengers(paginationModel.page + 1, paginationModel.pageSize);
      } else {
        alert(response?.message || `Failed to ${editMode ? 'update' : 'add'} passenger`);
      }
    } catch (err) {
      console.error(`${editMode ? 'Update' : 'Add'} passenger error:`, err);
      alert(`Failed to ${editMode ? 'update' : 'add'} passenger: ${err.message || 'Unknown error'}`);
    } finally {
      setSubmitting(false);
    }
  };

  const handleViewPassenger = (passenger) => {
    setSelectedPassenger(passenger);
    setOpenViewDialog(true);
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      .required('Name is required')
      .min(2, 'Name must be at least 2 characters'),
    gender: Yup.string().required('Gender is required'),
    phone: Yup.string()
      .required('Phone number is required')
      .matches(/^\+?[1-9]\d{1,14}$/, 'Please enter a valid phone number'),
    status: Yup.string().required('Status is required'),
  });

  const handleDeletePassenger = async (passengerId) => {
    if (!window.confirm('Are you sure you want to delete this passenger? This action cannot be undone.')) {
      return;
    }

    try {
      const response = await apiService.deletePassenger(passengerId);
      if (response && response.success) {
        alert('Passenger deleted successfully');
        fetchPassengers(paginationModel.page + 1, paginationModel.pageSize);
      } else {
        alert(response?.message || 'Failed to delete passenger');
      }
    } catch (err) {
      console.error('Delete passenger error:', err);
      alert('Failed to delete passenger');
    }
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      active: { label: 'Active', color: 'success' },
      blocked: { label: 'Blocked', color: 'error' },
      inactive: { label: 'Inactive', color: 'default' },
    };

    const config = statusConfig[status] || statusConfig.inactive;
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  // Calculate statistics from current page data
  const activePassengers = passengers.filter(p => p.status === 'active').length;
  const inactivePassengers = passengers.filter(p => p.status === 'inactive').length;
  const blockedPassengers = passengers.filter(p => p.status === 'blocked').length;

  const columns = [
    {
      field: 'profile_photo',
      headerName: 'Photo',
      width: 100,
      renderCell: (params) => {
        const photoUrl = params.row.profile_photo;
        if (!photoUrl) {
          return (
            <div style={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              background: '#FFC107',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: 20,
              color: '#000',
            }}>
              {(params.row.name || 'U').charAt(0).toUpperCase()}
            </div>
          );
        }
        
        const cleanPath = String(photoUrl).trim().replace(/^\/+/, '');
        const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
        const fullUrl = `${baseUrl}/${cleanPath}`;
        
        return (
          <img 
            src={fullUrl} 
            alt={params.row.name || 'User'}
            style={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #FFC107',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              // Show fallback
              const parent = e.target.parentElement;
              const fallback = document.createElement('div');
              fallback.style.cssText = `
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background: #FFC107;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 20px;
                color: #000;
              `;
              fallback.textContent = (params.row.name || 'U').charAt(0).toUpperCase();
              parent.appendChild(fallback);
            }}
          />
        );
      },
    },
    {
      field: 'name',
      headerName: 'Passenger Name',
      width: 200,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2" fontWeight={600}>
            {params.row.name || 'N/A'}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.phone}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'phone',
      headerName: 'Phone Number',
      width: 150,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) => getStatusChip(params.row.status),
    },
    {
      field: 'totalRides',
      headerName: 'Total Rides',
      width: 120,
      valueGetter: (params) => params.row.totalRides || 0,
    },
    {
      field: 'totalSpent',
      headerName: 'Total Spent',
      width: 130,
      renderCell: (params) => `₹${Number(params.row.totalSpent || 0).toLocaleString()}`,
    },
    {
      field: 'rating',
      headerName: 'Rating',
      width: 100,
      renderCell: (params) => (
        <Typography variant="body2">
          ⭐ {Number(params.row.rating || 5.0).toFixed(2)}
        </Typography>
      ),
    },
    {
      field: 'created_at',
      headerName: 'Joined',
      width: 150,
      valueGetter: (params) => params.row.created_at ? new Date(params.row.created_at).toLocaleDateString() : '-',
    },    
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton size="small" onClick={() => handleViewPassenger(params.row)}>
            <Visibility fontSize="small" />
          </IconButton>
          <IconButton size="small" color="primary" onClick={() => handleEditPassenger(params.row)}>
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            color="error"
            onClick={() => handleDeletePassenger(params.row.id)}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  // Filter passengers by search query (client-side filtering)
  const filteredPassengers = passengers.filter((passenger) =>
    (passenger.name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (passenger.phone || '').includes(searchQuery)
  );

  // Summary card component
  const SummaryCard = ({ title, value, icon, color, bgColor }) => (
    <Card sx={{ height: '100%', bgcolor: bgColor }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" fontWeight="bold">
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              bgcolor: color,
              borderRadius: '50%',
              p: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Passengers
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage all passenger accounts
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} onClick={handleAddPassenger}>
          Add Passenger
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title="Total Passengers"
            value={totalPassengersCount}
            icon={<People sx={{ color: 'white' }} />}
            color="#1976d2"
            bgColor="#e3f2fd"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title="Active (Current Page)"
            value={activePassengers}
            icon={<CheckCircle sx={{ color: 'white' }} />}
            color="#2e7d32"
            bgColor="#e8f5e9"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title="Inactive (Current Page)"
            value={inactivePassengers}
            icon={<PersonOff sx={{ color: 'white' }} />}
            color="#ed6c02"
            bgColor="#fff3e0"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title="Blocked (Current Page)"
            value={blockedPassengers}
            icon={<Block sx={{ color: 'white' }} />}
            color="#d32f2f"
            bgColor="#fde8e8"
          />
        </Grid>
      </Grid>

      <Card>
        <CardContent>
          <TextField
            fullWidth
            placeholder="Search by name or phone..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 3 }}
          />

          <DataGrid
            rows={filteredPassengers}
            columns={columns}
            rowCount={totalPassengersCount}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[10, 25, 50]}
            paginationMode="server"
            disableRowSelectionOnClick
            autoHeight
            loading={loading}
            getRowId={(row) => row.id}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        </CardContent>
      </Card>

      {/* View Passenger Dialog */}
      <Dialog open={openViewDialog} onClose={() => setOpenViewDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Passenger Details</DialogTitle>
        <DialogContent>
          {selectedPassenger && (
            <Box sx={{ pt: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Name</Typography>
                  <Typography variant="body1" fontWeight={600}>{selectedPassenger.name || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Phone</Typography>
                  <Typography variant="body1">{selectedPassenger.phone}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Gender</Typography>
                  <Typography variant="body1">{selectedPassenger.gender || 'Not specified'}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 0.5 }}>{getStatusChip(selectedPassenger.status)}</Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Total Rides</Typography>
                  <Typography variant="body1">{selectedPassenger.totalRides || 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Total Spent</Typography>
                  <Typography variant="body1">₹{Number(selectedPassenger.totalSpent || 0).toLocaleString()}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Rating</Typography>
                  <Typography variant="body1">⭐ {Number(selectedPassenger.rating || 0.0).toFixed(2)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Joined Date</Typography>
                  <Typography variant="body1">
                    {selectedPassenger.created_at ? new Date(selectedPassenger.created_at).toLocaleDateString() : '-'}
                  </Typography>
                </Grid>                
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Add/Edit Passenger Dialog */}
      <Dialog
        open={openAddDialog}
        onClose={() => {
          setOpenAddDialog(false);
          setSelectedPassenger(null);
          setEditMode(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{editMode ? 'Edit' : 'Add'} Passenger</DialogTitle>
        <Formik
          initialValues={{
            name: selectedPassenger?.name || '',
            gender: selectedPassenger?.gender || 'Male',
            phone: selectedPassenger?.phone || '',
            status: selectedPassenger?.status || 'active',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmitPassenger}
          enableReinitialize
        >
          {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
            <Form>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="name"
                      label="Name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      placeholder="Enter Full name"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth required>
                      <InputLabel>Gender</InputLabel>
                      <Select
                        name="gender"
                        value={values.gender}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Gender"
                        error={touched.gender && Boolean(errors.gender)}
                      >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Transgender">Transgender</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="phone"
                      label="Phone Number"
                      value={values.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone && errors.phone}
                      placeholder="+919876543210"
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Phone />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth required>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Status"
                        error={touched.status && Boolean(errors.status)}
                      >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                        <MenuItem value="blocked">Blocked</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  setOpenAddDialog(false);
                  setSelectedPassenger(null);
                  setEditMode(false);
                }}>Cancel</Button>
                <Button type="submit" variant="contained" disabled={isSubmitting}>
                  {editMode ? 'Update' : 'Add'} Passenger
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </Box>
  );
};

export default PassengersPage;